module.exports = __webpack_public_path__ + "media/forms/required-icon-ebc39aaf.png";